import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import About from './pages/About';
import PostManager from './compoonents/PostManager';
import AuthWrapper from './compoonents/AuthWrapper';
import OAuthSignInPage from './pages/OAuthSignInPage'
import HomePage from './pages/HomePage'


function App() {
  return (
    <Router>
      <AuthWrapper>
        <Routes>
          {/* Default route: redirect to /home */}
          {/* <Route path="/" element={<Navigate to="/home" replace />} /> */}
          <Route path="/" element={<HomePage/>} />

          {/* Main routes */}
          <Route path="/home" element={<HomePage />} />
          <Route path="/login" element={<OAuthSignInPage />} />
          <Route path="/about" element={<About />} />
          <Route path="/test" element={<PostManager />} />
        </Routes>
      </AuthWrapper>
    </Router>
  );
}

export default App;